"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ActivityReportingComponents = _interopRequireDefault(require("../../components/ActivityReportingComponents"));
var _ScheduledReportsTable = _interopRequireDefault(require("../../components/ReportSidePaneComponents/ScheduledReportsTable"));
var _DownloadReportForm = _interopRequireDefault(require("../../components/ReportSidePaneComponents/DownloadReportForm"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./TradeReportLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var layoutClasses = (0, _cssClassesHelper.getBEMClasses)('trade-report-layout');
var TradeReportLayout = function TradeReportLayout() {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('activity-report')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('activity-report-header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('activity-report-header-title')
  }, t('Activity Reporting')), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('activity-report-header-text')
  }, t('All of your activity on the exchange is available for you to download as a spreadsheet. Simply choose the type of activity and the timeframe to generate your report.'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('activity-report-buttons')
  }, /*#__PURE__*/_react["default"].createElement(_ActivityReportingComponents["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('cyclical-report')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('report-header')
  }, t('Cyclical Reports')), /*#__PURE__*/_react["default"].createElement(_ScheduledReportsTable["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('singal-report')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('report-header')
  }, t('Reports Available to Download')), /*#__PURE__*/_react["default"].createElement(_DownloadReportForm["default"], null)));
};
var _default = exports["default"] = TradeReportLayout;